import { Inject, forwardRef, Component, Injector, Input, EventEmitter, Output, NgModule } from '@angular/core';
import { HttpParams, HttpClient } from '@angular/common/http';
import { BadRequestError, NotFoundError, AppError } from '@mt-ng2/errors-module';
import { throwError, of, forkJoin } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ClaimValues, ClaimsService } from '@mt-ng2/auth-module';
import { NotificationsService } from '@mt-ng2/notifications-module';
import { markAllFormFieldsAsTouched } from '@mt-ng2/common-functions';
import { SearchParams } from '@mt-ng2/common-classes';
import { EntityListConfig, SortDirection, EntityListModule } from '@mt-ng2/entity-list-module';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DynamicFormModule } from '@mt-ng2/dynamic-form';
import { MtAlertsModule } from '@mt-ng2/alerts-module';
import { EntityComponentsPhonesModule } from '@mt-ng2/entity-components-phones';
import { MtSearchFilterSelectModule } from '@mt-ng2/search-filter-select-control';
import { MtSearchBarControlModule } from '@mt-ng2/searchbar-control';
import { EntityComponentsAddressesModule } from '@mt-ng2/entity-components-addresses';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@mt-ng2/auth-module';
import * as ɵngcc3 from '@mt-ng2/notifications-module';
import * as ɵngcc4 from '@angular/common';
import * as ɵngcc5 from '@mt-ng2/dynamic-form';
import * as ɵngcc6 from '@mt-ng2/entity-components-phones';
import * as ɵngcc7 from '@mt-ng2/entity-components-addresses';
import * as ɵngcc8 from '@mt-ng2/searchbar-control';
import * as ɵngcc9 from '@mt-ng2/entity-list-module';
import * as ɵngcc10 from '@mt-ng2/search-filter-select-control';

function SharedEntitiesInfoComponent_div_5_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 9);
    ɵngcc0.ɵɵtext(1, "\n                            ");
    ɵngcc0.ɵɵelement(2, "i", 10);
    ɵngcc0.ɵɵtext(3, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r4.isHovered);
} }
function SharedEntitiesInfoComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵlistener("mouseenter", function SharedEntitiesInfoComponent_div_5_Template_div_mouseenter_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.isHovered = true; })("mouseleave", function SharedEntitiesInfoComponent_div_5_Template_div_mouseleave_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.isHovered = false; })("click", function SharedEntitiesInfoComponent_div_5_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.edit(); });
    ɵngcc0.ɵɵtext(1, "\n                    ");
    ɵngcc0.ɵɵelementStart(2, "h4");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵtemplate(4, SharedEntitiesInfoComponent_div_5_span_4_Template, 4, 1, "span", 7);
    ɵngcc0.ɵɵtext(5, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n                    ");
    ɵngcc0.ɵɵelement(7, "app-dynamic-view", 8);
    ɵngcc0.ɵɵtext(8, "\n                ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("cursor", ctx_r0._canEdit ? "pointer" : "default");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("\n                        ", ctx_r0._sharedEntitiesConfig.EntityName, " Info\n                        ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0._canEdit);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("config", ctx_r0.config.viewOnly);
} }
function SharedEntitiesInfoComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtext(1, "\n                    ");
    ɵngcc0.ɵɵelementStart(2, "h4");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n                    ");
    ɵngcc0.ɵɵelementStart(5, "app-dynamic-form", 12);
    ɵngcc0.ɵɵlistener("[isEditing]", function SharedEntitiesInfoComponent_div_7_Template_app_dynamic_form__isEditing__5_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.isEditing; })("submitted", function SharedEntitiesInfoComponent_div_7_Template_app_dynamic_form_submitted_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.save($event); });
    ɵngcc0.ɵɵtext(6, "\n                        ");
    ɵngcc0.ɵɵelementStart(7, "button", 13);
    ɵngcc0.ɵɵtext(8, "Save");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(9, "\n                        ");
    ɵngcc0.ɵɵelementStart(10, "button", 14);
    ɵngcc0.ɵɵlistener("click", function SharedEntitiesInfoComponent_div_7_Template_button_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.cancelClick(); });
    ɵngcc0.ɵɵtext(11, "Cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(12, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(13, "\n                ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r1._sharedEntitiesConfig.EntityName, " Info");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("config", ctx_r1.config.formObject);
} }
function SharedEntitiesInfoComponent_ng_container_12_app_common_phone_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "app-common-phone", 17);
    ɵngcc0.ɵɵlistener("onSave", function SharedEntitiesInfoComponent_ng_container_12_app_common_phone_2_Template_app_common_phone_onSave_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const sharedEntity_r13 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.saveAdditionalSharedEntity($event, sharedEntity_r13); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const sharedEntity_r13 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r14 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("PhoneArray", ctx_r14.getAdditionalSharedEntities(sharedEntity_r13))("canEdit", ctx_r14._canEdit);
} }
function SharedEntitiesInfoComponent_ng_container_12_app_common_addresses_4_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "app-common-addresses", 18);
    ɵngcc0.ɵɵlistener("onSave", function SharedEntitiesInfoComponent_ng_container_12_app_common_addresses_4_Template_app_common_addresses_onSave_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const sharedEntity_r13 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.saveAdditionalSharedEntity($event, sharedEntity_r13); })("onDelete", function SharedEntitiesInfoComponent_ng_container_12_app_common_addresses_4_Template_app_common_addresses_onDelete_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const sharedEntity_r13 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.deleteAdditionalSharedEntity($event, sharedEntity_r13); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const sharedEntity_r13 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r15 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("addressContainerArray", ctx_r15.getAdditionalSharedEntities(sharedEntity_r13))("canEdit", ctx_r15._canEdit)("canAdd", ctx_r15._canEdit)("max", sharedEntity_r13.max)("useMaxAsLimit", sharedEntity_r13.useMaxAsLimit)("entityName", sharedEntity_r13.componentName);
} }
function SharedEntitiesInfoComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n                    ");
    ɵngcc0.ɵɵtemplate(2, SharedEntitiesInfoComponent_ng_container_12_app_common_phone_2_Template, 1, 2, "app-common-phone", 15);
    ɵngcc0.ɵɵtext(3, "\n                    ");
    ɵngcc0.ɵɵtemplate(4, SharedEntitiesInfoComponent_ng_container_12_app_common_addresses_4_Template, 1, 6, "app-common-addresses", 16);
    ɵngcc0.ɵɵtext(5, "\n                    ");
    ɵngcc0.ɵɵelement(6, "br");
    ɵngcc0.ɵɵtext(7, "\n                ");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const sharedEntity_r13 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.checkType(sharedEntity_r13.type, "Phone"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.checkType(sharedEntity_r13.type, "Address"));
} }
function SharedEntitiesInfoComponent_button_18_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 14);
    ɵngcc0.ɵɵlistener("click", function SharedEntitiesInfoComponent_button_18_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.closeClick(); });
    ɵngcc0.ɵɵtext(1, "Close");
    ɵngcc0.ɵɵelementEnd();
} }
function SharedEntitiesListComponent_mt_search_filter_select_7_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mt-search-filter-select", 6);
    ɵngcc0.ɵɵlistener("onSelectionChanged", function SharedEntitiesListComponent_mt_search_filter_select_7_Template_mt_search_filter_select_onSelectionChanged_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.filtersChanged(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const filter_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("items", filter_r3.FilterItems)("entity", filter_r3.Name);
} }
function SharedEntitiesListComponent_br_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "br");
} }
function SharedEntitiesListComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵlistener("click", function SharedEntitiesListComponent_div_18_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.addEntity(); });
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelementStart(2, "a", 8);
    ɵngcc0.ɵɵtext(3, "\n                    ");
    ɵngcc0.ɵɵelement(4, "span", 9);
    ɵngcc0.ɵɵtext(5, "\n                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} }
const _c0 = function () { return ["../"]; };
function SharedEntityComponent_div_1_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtext(1, "\n                    ");
    ɵngcc0.ɵɵelement(2, "i", 7);
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r2.isHovered);
} }
function SharedEntityComponent_div_1_app_dynamic_view_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "app-dynamic-view", 8);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("config", ctx_r3.config.viewOnly);
} }
function SharedEntityComponent_div_1_i_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i");
    ɵngcc0.ɵɵtext(1, "Not entered");
    ɵngcc0.ɵɵelementEnd();
} }
function SharedEntityComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵlistener("mouseenter", function SharedEntityComponent_div_1_Template_div_mouseenter_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.isHovered = true; })("mouseleave", function SharedEntityComponent_div_1_Template_div_mouseleave_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.isHovered = false; })("click", function SharedEntityComponent_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.edit(); });
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "h4");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵtemplate(4, SharedEntityComponent_div_1_span_4_Template, 4, 1, "span", 3);
    ɵngcc0.ɵɵtext(5, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n            ");
    ɵngcc0.ɵɵtemplate(7, SharedEntityComponent_div_1_app_dynamic_view_7_Template, 1, 1, "app-dynamic-view", 4);
    ɵngcc0.ɵɵtext(8, "\n            ");
    ɵngcc0.ɵɵtemplate(9, SharedEntityComponent_div_1_i_9_Template, 2, 0, "i", 5);
    ɵngcc0.ɵɵtext(10, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("cursor", ctx_r0._canEdit ? "pointer" : "default");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("\n                ", ctx_r0._sharedEntityConfig.EntityName, "\n                ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0._canEdit);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.entityId > 0);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.entityId === 0);
} }
function SharedEntityComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "h4");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n            ");
    ɵngcc0.ɵɵelementStart(5, "app-dynamic-form", 10);
    ɵngcc0.ɵɵlistener("[isEditing]", function SharedEntityComponent_div_3_Template_app_dynamic_form__isEditing__5_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.isEditing; })("submitted", function SharedEntityComponent_div_3_Template_app_dynamic_form_submitted_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.save($event); });
    ɵngcc0.ɵɵtext(6, "\n                ");
    ɵngcc0.ɵɵelementStart(7, "button", 11);
    ɵngcc0.ɵɵtext(8, "Save");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(9, "\n                ");
    ɵngcc0.ɵɵelementStart(10, "button", 12);
    ɵngcc0.ɵɵlistener("click", function SharedEntityComponent_div_3_Template_button_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.cancelClick(); });
    ɵngcc0.ɵɵtext(11, "Cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(12, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(13, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1._sharedEntityConfig.EntityName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("config", ctx_r1.config.formObject);
} }
function SharedEntitiesComponent_div_0_li_7_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 12);
    ɵngcc0.ɵɵlistener("click", function SharedEntitiesComponent_div_0_li_7_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const entity_r4 = ctx.$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.entitySelected(entity_r4); });
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelement(2, "div", 13);
    ɵngcc0.ɵɵtext(3, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const entity_r4 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r2._sharedEntitiesConfig.getRow(entity_r4), ɵngcc0.ɵɵsanitizeHtml);
} }
function SharedEntitiesComponent_div_0_i_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("No ", ctx_r3._sharedEntitiesConfig.EntityNamePluralized, "");
} }
function SharedEntitiesComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtext(1, "\n    ");
    ɵngcc0.ɵɵelementStart(2, "h4");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n    ");
    ɵngcc0.ɵɵelementStart(5, "ul", 3);
    ɵngcc0.ɵɵtext(6, "\n        ");
    ɵngcc0.ɵɵtemplate(7, SharedEntitiesComponent_div_0_li_7_Template, 4, 1, "li", 4);
    ɵngcc0.ɵɵtext(8, "\n    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(9, "\n    ");
    ɵngcc0.ɵɵtemplate(10, SharedEntitiesComponent_div_0_i_10_Template, 2, 1, "i", 5);
    ɵngcc0.ɵɵtext(11, "\n    ");
    ɵngcc0.ɵɵelementStart(12, "div", 6);
    ɵngcc0.ɵɵtext(13, "\n        ");
    ɵngcc0.ɵɵelementStart(14, "button", 7);
    ɵngcc0.ɵɵlistener("click", function SharedEntitiesComponent_div_0_Template_button_click_14_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.addEntity(); });
    ɵngcc0.ɵɵtext(15, "\n            ");
    ɵngcc0.ɵɵelement(16, "span", 8);
    ɵngcc0.ɵɵtext(17, "\n        ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(18, "\n    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(19, "\n    ");
    ɵngcc0.ɵɵelementStart(20, "div", 9);
    ɵngcc0.ɵɵtext(21, "\n        ");
    ɵngcc0.ɵɵelementStart(22, "span");
    ɵngcc0.ɵɵtext(23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(24, "\n    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(25, "\n    ");
    ɵngcc0.ɵɵelementStart(26, "div", 10);
    ɵngcc0.ɵɵtext(27, "\n        ");
    ɵngcc0.ɵɵelementStart(28, "a", 11);
    ɵngcc0.ɵɵlistener("click", function SharedEntitiesComponent_div_0_Template_a_click_28_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.seeAll(); });
    ɵngcc0.ɵɵtext(29, "Open Search");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(30, "\n    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(31, "\n");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0._sharedEntitiesConfig.EntityNamePluralized);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.entitiesArray);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.entitiesArray.length);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0._canAdd);
    ɵngcc0.ɵɵadvance(11);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r0._max > ctx_r0._total ? ctx_r0._total : ctx_r0._max, " of ", ctx_r0._total, "");
} }
function SharedEntitiesComponent_div_2_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 19);
    ɵngcc0.ɵɵlistener("click", function SharedEntitiesComponent_div_2_button_13_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.additionalInfo(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\n            ", ctx_r10.additionalInfoButtonOverride ? ctx_r10.additionalInfoButtonOverride : "Additional Info", "\n        ");
} }
function SharedEntitiesComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtext(1, "\n    ");
    ɵngcc0.ɵɵelementStart(2, "h4");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n    ");
    ɵngcc0.ɵɵelementStart(5, "app-dynamic-form", 15);
    ɵngcc0.ɵɵlistener("submitted", function SharedEntitiesComponent_div_2_Template_app_dynamic_form_submitted_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.save($event); });
    ɵngcc0.ɵɵtext(6, "\n        ");
    ɵngcc0.ɵɵelementStart(7, "button", 16);
    ɵngcc0.ɵɵtext(8, "\n            Save\n        ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(9, "\n        ");
    ɵngcc0.ɵɵelementStart(10, "button", 17);
    ɵngcc0.ɵɵlistener("click", function SharedEntitiesComponent_div_2_Template_button_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.selectedEntity = null; });
    ɵngcc0.ɵɵtext(11, "\n            Cancel\n        ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(12, "\n        ");
    ɵngcc0.ɵɵtemplate(13, SharedEntitiesComponent_div_2_button_13_Template, 2, 1, "button", 18);
    ɵngcc0.ɵɵtext(14, "\n    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(15, "\n");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("\n        ", (ctx_r1.selectedEntity.Id > 0 ? "Edit " : "Add ") + ctx_r1._sharedEntitiesConfig.EntityName, "\n    ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("config", ctx_r1.formObject);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showAdditionalInfoButton);
} }
var SharedEntitiesEditOptions;
(function (SharedEntitiesEditOptions) {
    SharedEntitiesEditOptions[SharedEntitiesEditOptions["InPlace"] = 0] = "InPlace";
    SharedEntitiesEditOptions[SharedEntitiesEditOptions["InPlaceWithAdditionalInfoButton"] = 1] = "InPlaceWithAdditionalInfoButton";
    SharedEntitiesEditOptions[SharedEntitiesEditOptions["InSeparatePage"] = 2] = "InSeparatePage";
})(SharedEntitiesEditOptions || (SharedEntitiesEditOptions = {}));
var AdditionalSharedEntityTypes;
(function (AdditionalSharedEntityTypes) {
    AdditionalSharedEntityTypes[AdditionalSharedEntityTypes["Phone"] = 0] = "Phone";
    AdditionalSharedEntityTypes[AdditionalSharedEntityTypes["Address"] = 1] = "Address";
    AdditionalSharedEntityTypes[AdditionalSharedEntityTypes["Custom"] = 2] = "Custom";
})(AdditionalSharedEntityTypes || (AdditionalSharedEntityTypes = {}));
class SharedEntitiesComponentConfig {
    constructor(EmptyEntity, EntityName, EntityNamePluralized, SharedEntityListConfig, EntityListItemsPerPage) {
        this.EmptyEntity = EmptyEntity;
        this.EntityName = EntityName;
        this.EntityNamePluralized = EntityNamePluralized;
        this.SharedEntityListConfig = SharedEntityListConfig;
        this.EntityListItemsPerPage = EntityListItemsPerPage;
        this.metaItemLists = [];
        this.MetaItemServices = [];
        this.AdditionalSharedEntities = [];
        this.SharedEntitiesEditOption = SharedEntitiesEditOptions.InPlace;
    }
    setMetaItemLists(lists) {
        this.metaItemLists = lists;
    }
    getMetaItemValues(serviceName) {
        let list = this.metaItemLists.find((item) => item.ServiceName === serviceName);
        return list.Items;
    }
}
class BlankSharedEntitiesConfig extends SharedEntitiesComponentConfig {
    constructor() {
        super({ Id: 0 }, '', '', { FilterServices: [], EntityListConfig: null }, 12);
        this.AdditionalSharedEntities = [];
        this.SharedEntitiesEditOption = SharedEntitiesEditOptions.InPlace;
        this.getRow = (entity) => '';
    }
    getFormValues(entity, formValue) {
        return Object.assign({}, this.EmptyEntity);
    }
    getDynamicFormConfig(entity) {
        return { formObject: [], viewOnly: [] };
    }
}
class SharedEntitiesService {
    constructor(baseurl, entityurl, http) {
        this.baseurl = baseurl;
        this.entityurl = entityurl;
        this.http = http;
    }
    getEntities(parentId, searchparameters) {
        let params = this.getHttpParams(searchparameters);
        return this.http
            .get(`${this.baseurl}/${parentId}${this.entityurl}/_search`, {
            observe: 'response',
            params: params,
        })
            .pipe(catchError(this.handleError));
    }
    getEntity(parentId, entityId) {
        return this.http.get(`${this.baseurl}/${parentId}${this.entityurl}/${entityId}`).pipe(catchError(this.handleError));
    }
    saveEntity(parentId, entity) {
        if (!entity.Id) {
            entity.Id = 0;
            return this.http.post(`${this.baseurl}/${parentId}${this.entityurl}`, entity);
        }
        else {
            return this.http.put(`${this.baseurl}/${parentId}${this.entityurl}/${entity.Id}`, entity, { responseType: 'text' });
        }
    }
    deleteEntity(parentId, entityId) {
        return this.http.delete(`${this.baseurl}/${parentId}${this.entityurl}/${entityId}`, { responseType: 'text' });
    }
    handleError(error) {
        if (error.status === 400) {
            return throwError(new BadRequestError(error.json()));
        }
        if (error.status === 404) {
            return throwError(new NotFoundError());
        }
        return throwError(new AppError(error));
    }
    getHttpParams(searchparameters) {
        var _a;
        let params = new HttpParams();
        if (searchparameters.query) {
            params = params.append('query', searchparameters.query);
        }
        if (searchparameters.skip) {
            params = params.append('skip', searchparameters.skip.toString());
        }
        if (searchparameters.take) {
            params = params.append('take', searchparameters.take.toString());
        }
        if (searchparameters.order) {
            params = params.append('order', searchparameters.order.toString());
        }
        if (searchparameters.orderDirection) {
            params = params.append('orderDirection', searchparameters.orderDirection.toString());
        }
        if (((_a = searchparameters.extraParams) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            let extraparams = new HttpParams();
            searchparameters.extraParams.forEach((param) => {
                if (param.valueArray) {
                    if (param.valueArray.length > 0) {
                        extraparams = extraparams.append(param.name, param.valueArray.toString());
                    }
                }
                else {
                    if (param.value.length > 0) {
                        extraparams = extraparams.set(param.name, param.value);
                    }
                }
            });
            if (extraparams.keys().length > 0) {
                params = params.append('extraparams', extraparams.toString());
            }
        }
        return params;
    }
}
SharedEntitiesService.ctorParameters = () => [
    { type: String },
    { type: String },
    { type: HttpClient, decorators: [{ type: Inject, args: [forwardRef(() => HttpClient),] }] }
];
class AdditionalSharedEntityConfig {
    constructor(type, accessorFunction, saveMethodName, deleteMethodName, componentName = null, max = 0, useMaxAsLimit = false) {
        this.type = type;
        this.accessorFunction = accessorFunction;
        this.saveMethodName = saveMethodName;
        this.deleteMethodName = deleteMethodName;
        this.componentName = componentName;
        this.max = max;
        this.useMaxAsLimit = useMaxAsLimit;
        if (!this.componentName) {
            this.componentName = this.getDefaultComponentName();
        }
    }
    getDefaultComponentName() {
        switch (this.type) {
            case AdditionalSharedEntityTypes.Address:
                return 'Address';
            case AdditionalSharedEntityTypes.Phone:
                return 'Phone';
            default:
                return '';
        }
    }
}

class SharedEntityComponentConfig {
    constructor(EmptyEntity, EntityName, MetaItemServices) {
        this.EmptyEntity = EmptyEntity;
        this.EntityName = EntityName;
        this.MetaItemServices = MetaItemServices;
        this.metaItemLists = [];
    }
    setMetaItemLists(lists) {
        this.metaItemLists = lists;
    }
    getMetaItemValues(serviceName) {
        let list = this.metaItemLists.find((item) => item.ServiceName === serviceName);
        return list.Items;
    }
}
class BlankSharedEntityConfig {
    constructor() {
        this.EmptyEntity = { Id: 0 };
        this.EntityName = '';
        this.MetaItemServices = [];
    }
    setMetaItemLists(lists) { }
    getFormValues(entity, formValue) {
        return Object.assign({}, this.EmptyEntity);
    }
    getDynamicFormConfig(entity) {
        return { formObject: [], viewOnly: [] };
    }
}
/*
    This used to be a separate service, which we are including for backwards compatibility.
*/
class SharedEntityService extends SharedEntitiesService {
}

class SharedEntitiesInfoComponent {
    constructor(route, injector, claimsService, notificationsService, router) {
        this.route = route;
        this.injector = injector;
        this.claimsService = claimsService;
        this.notificationsService = notificationsService;
        this.router = router;
        this._entity = { Id: 0 };
        this._sharedEntitiesConfig = new BlankSharedEntitiesConfig();
        this.config = { formObject: [], viewOnly: [] };
    }
    get entity() {
        return this._entity;
    }
    set entity(value) {
        this._entity = value;
        this.config = this._sharedEntitiesConfig.getDynamicFormConfig(value);
        this.additionalSharedEntities.forEach((item) => (item.value = null));
    }
    set canEdit(value) {
        this._canEdit = value;
    }
    get service() {
        if (this._service) {
            return this._service;
        }
        return null;
    }
    set service(value) {
        this._service = value;
    }
    get additionalSharedEntities() {
        return this._sharedEntitiesConfig.AdditionalSharedEntities;
    }
    ngOnInit() {
        this.isEditing = false;
        this.setVariables();
    }
    setVariables() {
        const config = this.route.parent.snapshot.data;
        this.parentId = +this.route.parent.snapshot.paramMap.get(config.entityIdParam);
        this.canEdit = this.claimsService.hasClaim(config.claimType, [ClaimValues.FullAccess]);
        let sharedEntityConfig = config;
        let componentPath = this.router.url.split('/')[this.router.url.split('/').length - 2];
        let sharedEntity = sharedEntityConfig.sharedEntities.find((item) => item.path === componentPath);
        this.service = this.injector.get(sharedEntity.service);
        this._sharedEntitiesConfig = new sharedEntity.config();
        this.entityId = +this.route.snapshot.paramMap.get(sharedEntity.entityIdParam);
        this._canEdit = (config === null || config === void 0 ? void 0 : config.claimType) ? this.claimsService.hasClaim(config.claimType, [ClaimValues.FullAccess]) : false;
        this.getInitilizationProcesses().subscribe((answer) => {
            this._sharedEntitiesConfig.setMetaItemLists(answer);
            if (this.entityId > 0) {
                this.getEntity();
            }
            else {
                this.entity = Object.assign({}, this._sharedEntitiesConfig.EmptyEntity);
                this.isEditing = true;
            }
        });
    }
    getInitilizationProcesses() {
        let observables = [];
        let metaItemServices = this._sharedEntitiesConfig.MetaItemServices;
        for (let mis of metaItemServices) {
            let metaItemService = this.injector.get(mis);
            observables.push(metaItemService.MetaItemListServiceInitilizer.getItems());
        }
        if (observables.length === 0) {
            return of([]);
        }
        return forkJoin(observables);
    }
    getEntity() {
        this.service.getEntity(this.parentId, this.entityId).subscribe((entity) => {
            this.entity = entity;
        });
    }
    edit() {
        if (this._canEdit) {
            this.isEditing = true;
        }
    }
    cancelClick() {
        if (this.entity.Id === 0) {
            this.router.navigate(['../'], { relativeTo: this.route });
        }
        else {
            this.isEditing = false;
        }
    }
    closeClick() {
        this.router.navigate(['../'], { relativeTo: this.route });
    }
    save(entityForm) {
        if (entityForm.valid) {
            let entity = this._sharedEntitiesConfig.getFormValues(this.entity, entityForm.value);
            this.saveEntity(entity);
        }
        else {
            this.notificationsService.error('Save Failed');
            markAllFormFieldsAsTouched(entityForm);
        }
    }
    saveEntity(entity) {
        this.service.saveEntity(this.parentId, entity).subscribe((success) => {
            this.notificationsService.success(`${this._sharedEntitiesConfig.EntityName} Saved Successfully`);
            if (this.entityId === 0) {
                this.entityId = success;
            }
            this.getEntity();
            this.isEditing = false;
        }, (error) => this.notificationsService.error('Save Failed'));
    }
    checkType(type, typeNameToCheck) {
        return type === AdditionalSharedEntityTypes[typeNameToCheck];
    }
    getAdditionalSharedEntities(sharedentity) {
        if (!sharedentity.value) {
            sharedentity.value = sharedentity.accessorFunction(this.entity);
        }
        return sharedentity.value;
    }
    saveAdditionalSharedEntity(additionalEntity, sharedentity) {
        this.service[sharedentity.saveMethodName](this.parentId, this.entityId, additionalEntity).subscribe((success) => {
            this.notificationsService.success(`${sharedentity.componentName} Saved Successfully`);
            this.getEntity();
            this.isEditing = false;
        }, (error) => this.notificationsService.error('Save Failed'));
    }
    deleteAdditionalSharedEntity(additionalEntity, sharedentity) {
        this.service[sharedentity.deleteMethodName](this.parentId, this.entityId, additionalEntity).subscribe((success) => {
            this.notificationsService.success(`${sharedentity.componentName} Deleted Successfully`);
            this.getEntity();
            this.isEditing = false;
        }, (error) => this.notificationsService.error('Save Failed'));
    }
}
SharedEntitiesInfoComponent.ɵfac = function SharedEntitiesInfoComponent_Factory(t) { return new (t || SharedEntitiesInfoComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ClaimsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NotificationsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router)); };
SharedEntitiesInfoComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SharedEntitiesInfoComponent, selectors: [["shared-entities-info"]], inputs: { canEdit: "canEdit" }, decls: 20, vars: 4, consts: [[1, "row"], [1, "col-md-6"], ["class", "miles-editable miles-card padded", 3, "cursor", "mouseenter", "mouseleave", "click", 4, "ngIf"], ["class", "miles-form padded", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["type", "button", "Class", "btn btn-flat btn-default", 3, "click", 4, "ngIf"], [1, "miles-editable", "miles-card", "padded", 3, "mouseenter", "mouseleave", "click"], ["class", "pull-right", 3, "hidden", 4, "ngIf"], [3, "config"], [1, "pull-right", 3, "hidden"], [1, "fa", "fa-lg", "fa-edit"], [1, "miles-form", "padded"], [3, "config", "[isEditing]", "submitted"], ["type", "submit", "Class", "btn btn-flat btn-success"], ["type", "button", "Class", "btn btn-flat btn-default", 3, "click"], [3, "PhoneArray", "canEdit", "onSave", 4, "ngIf"], [3, "addressContainerArray", "canEdit", "canAdd", "max", "useMaxAsLimit", "entityName", "onSave", "onDelete", 4, "ngIf"], [3, "PhoneArray", "canEdit", "onSave"], [3, "addressContainerArray", "canEdit", "canAdd", "max", "useMaxAsLimit", "entityName", "onSave", "onDelete"]], template: function SharedEntitiesInfoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵtext(2, "\n            ");
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵtext(4, "\n                ");
        ɵngcc0.ɵɵtemplate(5, SharedEntitiesInfoComponent_div_5_Template, 9, 5, "div", 2);
        ɵngcc0.ɵɵtext(6, "\n                ");
        ɵngcc0.ɵɵtemplate(7, SharedEntitiesInfoComponent_div_7_Template, 14, 2, "div", 3);
        ɵngcc0.ɵɵtext(8, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(9, "\n            ");
        ɵngcc0.ɵɵelementStart(10, "div", 1);
        ɵngcc0.ɵɵtext(11, "\n                ");
        ɵngcc0.ɵɵtemplate(12, SharedEntitiesInfoComponent_ng_container_12_Template, 8, 2, "ng-container", 4);
        ɵngcc0.ɵɵtext(13, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(14, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(15, "\n        ");
        ɵngcc0.ɵɵelement(16, "br");
        ɵngcc0.ɵɵtext(17, "\n        ");
        ɵngcc0.ɵɵtemplate(18, SharedEntitiesInfoComponent_button_18_Template, 2, 0, "button", 5);
        ɵngcc0.ɵɵtext(19, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isEditing && ctx.entity.Id > 0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isEditing);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.additionalSharedEntities);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isEditing && ctx.entity.Id > 0);
    } }, directives: [ɵngcc4.NgIf, ɵngcc4.NgForOf, ɵngcc5.DynamicViewComponent, ɵngcc5.DynamicFormComponent, ɵngcc6.CommonPhoneComponent, ɵngcc7.CommonAddressesComponent], encapsulation: 2 });
SharedEntitiesInfoComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: Injector },
    { type: ClaimsService },
    { type: NotificationsService },
    { type: Router }
];
SharedEntitiesInfoComponent.propDecorators = {
    canEdit: [{ type: Input, args: ['canEdit',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SharedEntitiesInfoComponent, [{
        type: Component,
        args: [{
                selector: 'shared-entities-info',
                template: `
        <div class="row">
            <div class="col-md-6">
                <div
                    class="miles-editable miles-card padded"
                    *ngIf="!isEditing && entity.Id > 0"
                    (mouseenter)="isHovered = true"
                    (mouseleave)="isHovered = false"
                    (click)="edit()"
                    [style.cursor]="_canEdit ? 'pointer' : 'default'"
                >
                    <h4>
                        {{ _sharedEntitiesConfig.EntityName }} Info
                        <span class="pull-right" *ngIf="_canEdit" [hidden]="!isHovered">
                            <i class="fa fa-lg fa-edit"></i>
                        </span>
                    </h4>
                    <app-dynamic-view [config]="config.viewOnly"></app-dynamic-view>
                </div>
                <div *ngIf="isEditing" class="miles-form padded">
                    <h4>{{ _sharedEntitiesConfig.EntityName }} Info</h4>
                    <app-dynamic-form [config]="config.formObject" ([isEditing])="(isEditing)" (submitted)="save($event)">
                        <button type="submit" Class="btn btn-flat btn-success">Save</button>
                        <button type="button" Class="btn btn-flat btn-default" (click)="cancelClick()">Cancel</button>
                    </app-dynamic-form>
                </div>
            </div>
            <div class="col-md-6">
                <ng-container *ngFor="let sharedEntity of additionalSharedEntities">
                    <app-common-phone
                        *ngIf="checkType(sharedEntity.type, 'Phone')"
                        [PhoneArray]="getAdditionalSharedEntities(sharedEntity)"
                        (onSave)="saveAdditionalSharedEntity($event, sharedEntity)"
                        [canEdit]="_canEdit"
                    ></app-common-phone>
                    <app-common-addresses
                        *ngIf="checkType(sharedEntity.type, 'Address')"
                        [addressContainerArray]="getAdditionalSharedEntities(sharedEntity)"
                        (onSave)="saveAdditionalSharedEntity($event, sharedEntity)"
                        (onDelete)="deleteAdditionalSharedEntity($event, sharedEntity)"
                        [canEdit]="_canEdit"
                        [canAdd]="_canEdit"
                        [max]="sharedEntity.max"
                        [useMaxAsLimit]="sharedEntity.useMaxAsLimit"
                        [entityName]="sharedEntity.componentName"
                    ></app-common-addresses>
                    <br />
                </ng-container>
            </div>
        </div>
        <br />
        <button *ngIf="!isEditing && entity.Id > 0" type="button" Class="btn btn-flat btn-default" (click)="closeClick()">Close</button>
    `
            }]
    }], function () { return [{ type: ɵngcc1.ActivatedRoute }, { type: ɵngcc0.Injector }, { type: ɵngcc2.ClaimsService }, { type: ɵngcc3.NotificationsService }, { type: ɵngcc1.Router }]; }, { canEdit: [{
            type: Input,
            args: ['canEdit']
        }] }); })();

class SharedEntitiesListComponent {
    constructor(route, router, injector, notificationsService, claimsService) {
        this.route = route;
        this.router = router;
        this.injector = injector;
        this.notificationsService = notificationsService;
        this.claimsService = claimsService;
        this._entitiesArray = [];
        this.itemsPerPage = 12;
        this.currentPage = 1;
        this.query = '';
        this.order = '';
        this.orderDirection = '';
        this.filters = [];
        this.entityListConfig = new EntityListConfig({
            columns: null,
        });
        this._sharedEntitiesConfig = new BlankSharedEntitiesConfig();
    }
    get entitiesArray() {
        return this._entitiesArray;
    }
    set canEdit(value) {
        this._canEdit = value;
    }
    get canEdit() {
        return this._canEdit;
    }
    get service() {
        if (this._service && this.id && this.id > 0) {
            return this._service;
        }
        return null;
    }
    set service(value) {
        this._service = value;
    }
    ngOnInit() {
        const config = this.route.parent.snapshot.data;
        this.id = +this.route.parent.snapshot.paramMap.get(config.entityIdParam);
        this.canEdit = this.claimsService.hasClaim(config.claimType, [ClaimValues.FullAccess]);
        let sharedEntityConfig = config;
        let sharedEntity = sharedEntityConfig.sharedEntities.find((item) => item.path === this.route.snapshot.url[0].path);
        this.service = this.injector.get(sharedEntity.service);
        this._sharedEntitiesConfig = new sharedEntity.config();
        this.entityListConfig = this._sharedEntitiesConfig.SharedEntityListConfig.EntityListConfig;
        this.order = this.entityListConfig.getDefaultSortProperty();
        this.orderDirection = this.entityListConfig.getDefaultSortDirection();
        let filterServices = this._sharedEntitiesConfig.SharedEntityListConfig.FilterServices;
        for (let fs of filterServices) {
            let filterService = this.injector.get(fs);
            filterService.MetaItemListServiceInitilizer.getItems().subscribe((answer) => {
                this.filters.push(answer);
            });
        }
        this.itemsPerPage = this._sharedEntitiesConfig.EntityListItemsPerPage;
        this.getEntities();
    }
    search(query) {
        this.query = query;
        this.currentPage = 1;
        this.getEntities();
    }
    columnSorted(event) {
        this.order = event.column.sort.sortProperty;
        this.orderDirection = event.column.sort.direction === SortDirection.Desc ? 'desc' : 'asc';
        this.getEntities();
    }
    filtersChanged() {
        this.currentPage = 1;
        this.getEntities();
    }
    getSelectedFilters(filterObj) {
        return filterObj.filter((item) => item.Selected).map((item) => item.Item.Id);
    }
    getExtraSearchParams() {
        const _extraSearchParams = [];
        for (let filter of this.filters) {
            _extraSearchParams.push(filter.toExtraSearchParams());
        }
        return _extraSearchParams;
    }
    getEntities() {
        let search = this.query;
        const extraSearchParams = this.getExtraSearchParams();
        const searchEntity = {
            extraParams: extraSearchParams,
            order: this.order,
            orderDirection: this.orderDirection,
            query: (search === null || search === void 0 ? void 0 : search.length) > 0 ? search : '',
            skip: (this.currentPage - 1) * this.itemsPerPage,
            take: this.itemsPerPage,
        };
        const searchparams = new SearchParams(searchEntity);
        this.service.getEntities(this.id, searchparams).subscribe((response) => {
            this._entitiesArray = response.body;
            this.total = +response.headers.get('X-List-Count');
        });
        return this._entitiesArray;
    }
    deleteEntity(event) {
        this.deleteEntityById(event.entity.Id);
    }
    deleteEntityById(entityId) {
        this.service.deleteEntity(this.id, entityId).subscribe((answer) => {
            this.notificationsService.success(`${this._sharedEntitiesConfig.EntityName} Deleted Successfully`);
            this.getEntities();
        });
    }
    selectEntity(event) {
        this.router.navigate([`${event.entity.Id}`], { relativeTo: this.route });
    }
    addEntity() {
        this.router.navigate(['0'], { relativeTo: this.route });
    }
}
SharedEntitiesListComponent.ɵfac = function SharedEntitiesListComponent_Factory(t) { return new (t || SharedEntitiesListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NotificationsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ClaimsService)); };
SharedEntitiesListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SharedEntitiesListComponent, selectors: [["shared-entities-list"]], decls: 21, vars: 10, consts: [[3, "onSearch"], [3, "items", "entity", "onSelectionChanged", 4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "entities", "itemsPerPage", "total", "currentPage", "entityListConfig", "currentPageChange", "onPageChanged", "onItemSelected", "onItemDeleted", "onColumnSorted"], [1, "btn", "btn-default", 3, "routerLink"], ["class", "fab-wrap-b-r", 3, "click", 4, "ngIf"], [3, "items", "entity", "onSelectionChanged"], [1, "fab-wrap-b-r", 3, "click"], [1, "btn", "btn-primary", "btn-fab-lg"], [1, "fa", "fa-plus"]], template: function SharedEntitiesListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵtext(2, "\n            ");
        ɵngcc0.ɵɵelementStart(3, "div");
        ɵngcc0.ɵɵtext(4, "\n                ");
        ɵngcc0.ɵɵelementStart(5, "mt-search-bar", 0);
        ɵngcc0.ɵɵlistener("onSearch", function SharedEntitiesListComponent_Template_mt_search_bar_onSearch_5_listener($event) { return ctx.search($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(6, "\n                ");
        ɵngcc0.ɵɵtemplate(7, SharedEntitiesListComponent_mt_search_filter_select_7_Template, 1, 2, "mt-search-filter-select", 1);
        ɵngcc0.ɵɵtext(8, "\n                ");
        ɵngcc0.ɵɵtemplate(9, SharedEntitiesListComponent_br_9_Template, 1, 0, "br", 2);
        ɵngcc0.ɵɵtext(10, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(11, "\n            ");
        ɵngcc0.ɵɵelementStart(12, "entity-list", 3);
        ɵngcc0.ɵɵlistener("currentPageChange", function SharedEntitiesListComponent_Template_entity_list_currentPageChange_12_listener($event) { return ctx.currentPage = $event; })("onPageChanged", function SharedEntitiesListComponent_Template_entity_list_onPageChanged_12_listener() { return ctx.getEntities(); })("onItemSelected", function SharedEntitiesListComponent_Template_entity_list_onItemSelected_12_listener($event) { return ctx.selectEntity($event); })("onItemDeleted", function SharedEntitiesListComponent_Template_entity_list_onItemDeleted_12_listener($event) { return ctx.deleteEntity($event); })("onColumnSorted", function SharedEntitiesListComponent_Template_entity_list_onColumnSorted_12_listener($event) { return ctx.columnSorted($event); });
        ɵngcc0.ɵɵtext(13, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(14, "\n            ");
        ɵngcc0.ɵɵelementStart(15, "a", 4);
        ɵngcc0.ɵɵtext(16, "Back");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(17, "\n            ");
        ɵngcc0.ɵɵtemplate(18, SharedEntitiesListComponent_div_18_Template, 7, 0, "div", 5);
        ɵngcc0.ɵɵtext(19, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(20, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.filters);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !(ctx.filters && ctx.filters.length && ctx.filters.length > 0));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("entities", ctx.entitiesArray)("itemsPerPage", ctx.itemsPerPage)("total", ctx.total)("currentPage", ctx.currentPage)("entityListConfig", ctx.entityListConfig);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction0(9, _c0));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.canEdit);
    } }, directives: [ɵngcc8.MtSearchBarComponent, ɵngcc4.NgForOf, ɵngcc4.NgIf, ɵngcc9.EntityListComponent, ɵngcc1.RouterLinkWithHref, ɵngcc10.MtSearchFilterSelectComponent], encapsulation: 2 });
SharedEntitiesListComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: Router },
    { type: Injector },
    { type: NotificationsService },
    { type: ClaimsService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SharedEntitiesListComponent, [{
        type: Component,
        args: [{
                selector: 'shared-entities-list',
                template: `
        <div>
            <div>
                <mt-search-bar (onSearch)="search($event)"></mt-search-bar>
                <mt-search-filter-select
                    *ngFor="let filter of filters"
                    [items]="filter.FilterItems"
                    [entity]="filter.Name"
                    (onSelectionChanged)="filtersChanged()"
                ></mt-search-filter-select>
                <br *ngIf="!(filters && filters.length && filters.length > 0)" />
            </div>
            <entity-list
                [entities]="entitiesArray"
                [itemsPerPage]="itemsPerPage"
                [total]="total"
                [(currentPage)]="currentPage"
                (onPageChanged)="getEntities()"
                (onItemSelected)="selectEntity($event)"
                (onItemDeleted)="deleteEntity($event)"
                (onColumnSorted)="columnSorted($event)"
                [entityListConfig]="entityListConfig"
            >
            </entity-list>
            <a [routerLink]="['../']" class="btn btn-default">Back</a>
            <div *ngIf="canEdit" class="fab-wrap-b-r" (click)="addEntity()">
                <a class="btn btn-primary btn-fab-lg">
                    <span class="fa fa-plus"></span>
                </a>
            </div>
        </div>
    `
            }]
    }], function () { return [{ type: ɵngcc1.ActivatedRoute }, { type: ɵngcc1.Router }, { type: ɵngcc0.Injector }, { type: ɵngcc3.NotificationsService }, { type: ɵngcc2.ClaimsService }]; }, null); })();

class SharedEntityComponent {
    constructor(route, injector, claimsService, notificationsService, router) {
        this.route = route;
        this.injector = injector;
        this.claimsService = claimsService;
        this.notificationsService = notificationsService;
        this.router = router;
        this._entity = { Id: 0 };
        this._sharedEntityConfig = new BlankSharedEntityConfig();
        this.config = { formObject: [], viewOnly: [] };
        this.isEditing = false;
    }
    set sharedEntity(value) {
        this._sharedEntityEnum = value;
    }
    get entity() {
        return this._entity;
    }
    set entity(value) {
        this._entity = value;
        this.config = this._sharedEntityConfig.getDynamicFormConfig(value);
    }
    set canEdit(value) {
        this._canEdit = value;
    }
    ngOnInit() {
        this.setVariables();
    }
    setVariables() {
        const config = this.route.parent.snapshot.data;
        if (config === null || config === void 0 ? void 0 : config.entityIdParam) {
            this.parentId = +this.route.parent.snapshot.paramMap.get(config.entityIdParam);
        }
        if (config) {
            let sharedEntityConfig = config;
            let sharedEntity = sharedEntityConfig.sharedEntities.find((item) => item.sharedEntity === this._sharedEntityEnum);
            this.service = this.injector.get(sharedEntity.service);
            this._sharedEntityConfig = new sharedEntity.config();
        }
        if (this._canEdit === undefined) {
            this._canEdit = (config === null || config === void 0 ? void 0 : config.claimType) ? this.claimsService.hasClaim(config.claimType, [ClaimValues.FullAccess]) : false;
        }
        this.getInitilizationProcesses().subscribe((answer) => {
            this._sharedEntityConfig.setMetaItemLists(answer);
            if (this.entityId > 0) {
                this.getEntity();
            }
            else {
                this.entity = Object.assign({}, this._sharedEntityConfig.EmptyEntity);
            }
        });
    }
    getInitilizationProcesses() {
        let observables = [];
        let metaItemServices = this._sharedEntityConfig.MetaItemServices;
        for (let mis of metaItemServices) {
            let metaItemService = this.injector.get(mis);
            observables.push(metaItemService.MetaItemListServiceInitilizer.getItems());
        }
        return forkJoin(observables);
    }
    getEntity() {
        this.service.getEntity(this.parentId, this.entityId).subscribe((entity) => {
            this.entity = entity;
        });
    }
    edit() {
        if (this._canEdit) {
            this.isEditing = true;
        }
    }
    cancelClick() {
        this.isEditing = false;
    }
    save(entityForm) {
        if (entityForm.valid) {
            let entity = this._sharedEntityConfig.getFormValues(this.entity, entityForm.value);
            this.saveEntity(entity);
        }
        else {
            this.notificationsService.error('Save Failed');
            markAllFormFieldsAsTouched(entityForm);
        }
    }
    saveEntity(entity) {
        this.service.saveEntity(this.parentId, entity).subscribe((success) => {
            this.notificationsService.success(`${this._sharedEntityConfig.EntityName} Saved Successfully`);
            if (this.entityId === 0) {
                this.entityId = success;
            }
            this.getEntity();
            this.isEditing = false;
        }, (error) => this.notificationsService.error('Save Failed'));
    }
}
SharedEntityComponent.ɵfac = function SharedEntityComponent_Factory(t) { return new (t || SharedEntityComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ClaimsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NotificationsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router)); };
SharedEntityComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SharedEntityComponent, selectors: [["shared-entity"]], inputs: { sharedEntity: ["sharedEntityId", "sharedEntity"], canEdit: "canEdit", entityId: "entityId" }, decls: 5, vars: 2, consts: [["class", "miles-editable miles-card padded", 3, "cursor", "mouseenter", "mouseleave", "click", 4, "ngIf"], ["class", "miles-form padded", 4, "ngIf"], [1, "miles-editable", "miles-card", "padded", 3, "mouseenter", "mouseleave", "click"], ["class", "pull-right", 3, "hidden", 4, "ngIf"], [3, "config", 4, "ngIf"], [4, "ngIf"], [1, "pull-right", 3, "hidden"], [1, "fa", "fa-lg", "fa-edit"], [3, "config"], [1, "miles-form", "padded"], [3, "config", "[isEditing]", "submitted"], ["type", "submit", "Class", "btn btn-flat btn-success"], ["type", "button", "Class", "btn btn-flat btn-default", 3, "click"]], template: function SharedEntityComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵtemplate(1, SharedEntityComponent_div_1_Template, 11, 6, "div", 0);
        ɵngcc0.ɵɵtext(2, "\n        ");
        ɵngcc0.ɵɵtemplate(3, SharedEntityComponent_div_3_Template, 14, 2, "div", 1);
        ɵngcc0.ɵɵtext(4, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isEditing);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isEditing);
    } }, directives: [ɵngcc4.NgIf, ɵngcc5.DynamicViewComponent, ɵngcc5.DynamicFormComponent], encapsulation: 2 });
SharedEntityComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: Injector },
    { type: ClaimsService },
    { type: NotificationsService },
    { type: Router }
];
SharedEntityComponent.propDecorators = {
    entityId: [{ type: Input }],
    sharedEntity: [{ type: Input, args: ['sharedEntityId',] }],
    canEdit: [{ type: Input, args: ['canEdit',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SharedEntityComponent, [{
        type: Component,
        args: [{
                selector: 'shared-entity',
                template: `
        <div
            class="miles-editable miles-card padded"
            *ngIf="!isEditing"
            (mouseenter)="isHovered = true"
            (mouseleave)="isHovered = false"
            (click)="edit()"
            [style.cursor]="_canEdit ? 'pointer' : 'default'"
        >
            <h4>
                {{ _sharedEntityConfig.EntityName }}
                <span class="pull-right" *ngIf="_canEdit" [hidden]="!isHovered">
                    <i class="fa fa-lg fa-edit"></i>
                </span>
            </h4>
            <app-dynamic-view *ngIf="entityId > 0" [config]="config.viewOnly"></app-dynamic-view>
            <i *ngIf="entityId === 0">Not entered</i>
        </div>
        <div *ngIf="isEditing" class="miles-form padded">
            <h4>{{ _sharedEntityConfig.EntityName }}</h4>
            <app-dynamic-form [config]="config.formObject" ([isEditing])="(isEditing)" (submitted)="save($event)">
                <button type="submit" Class="btn btn-flat btn-success">Save</button>
                <button type="button" Class="btn btn-flat btn-default" (click)="cancelClick()">Cancel</button>
            </app-dynamic-form>
        </div>
    `
            }]
    }], function () { return [{ type: ɵngcc1.ActivatedRoute }, { type: ɵngcc0.Injector }, { type: ɵngcc2.ClaimsService }, { type: ɵngcc3.NotificationsService }, { type: ɵngcc1.Router }]; }, { sharedEntity: [{
            type: Input,
            args: ['sharedEntityId']
        }], canEdit: [{
            type: Input,
            args: ['canEdit']
        }], entityId: [{
            type: Input
        }] }); })();

class SharedEntitiesComponent {
    constructor(route, router, injector, notificationsService, claimsService) {
        this.route = route;
        this.router = router;
        this.injector = injector;
        this.notificationsService = notificationsService;
        this.claimsService = claimsService;
        this._sharedEntitiesConfig = new BlankSharedEntitiesConfig();
        this._entities = [];
        this.entitysPassedIn = false;
        this._max = 3;
        this.order = '';
        this.orderDirection = '';
        this.entityListConfig = new EntityListConfig({
            columns: null,
        });
        this.onSave = new EventEmitter();
        this.onDelete = new EventEmitter();
        this._selectedEntity = null;
        this.states = [[]];
    }
    set sharedEntity(value) {
        this._sharedEntityEnum = value;
    }
    get entitiesArray() {
        return this._entities;
    }
    set entitiesArray(value) {
        this.entitysPassedIn = true;
        this._entities = value;
        this.selectedEntity = null;
    }
    set total(value) {
        this._total = value;
    }
    set canEdit(value) {
        this._canEdit = value;
    }
    set canAdd(value) {
        this._canAdd = value;
    }
    set seeAllUrl(value) {
        this._seeAllUrl = value;
    }
    set max(value) {
        this._max = value;
    }
    get selectedEntity() {
        return this._selectedEntity;
    }
    set selectedEntity(value) {
        this._selectedEntity = value;
        if (value) {
            this.formObject = this._sharedEntitiesConfig.getDynamicFormConfig(value).formObject;
        }
    }
    get showAdditionalInfoButton() {
        return (this._sharedEntitiesConfig.SharedEntitiesEditOption === SharedEntitiesEditOptions.InPlaceWithAdditionalInfoButton &&
            this.selectedEntity.Id > 0);
    }
    get isEditing() {
        return this.selectedEntity && this._canEdit;
    }
    ngOnInit() {
        this.setVariables();
    }
    /**
     * Assigns local variables to defaults or config properties.
     */
    setVariables() {
        const config = this.route.parent.snapshot.data;
        if (config === null || config === void 0 ? void 0 : config.entityIdParam) {
            this.parentId = +this.route.parent.snapshot.paramMap.get(config.entityIdParam);
        }
        if (config && config.sharedEntities) {
            let sharedEntityConfig = config;
            let sharedEntity = sharedEntityConfig.sharedEntities.find((item) => item.sharedEntity === this._sharedEntityEnum);
            if (sharedEntity) {
                this.service = this.injector.get(sharedEntity.service);
                this._sharedEntitiesConfig = new sharedEntity.config();
                this.entityListConfig = this._sharedEntitiesConfig.SharedEntityListConfig.EntityListConfig;
                this.order = this.entityListConfig.getDefaultSortProperty();
                this.orderDirection = this.entityListConfig.getDefaultSortDirection();
            }
        }
        if (this._canEdit === undefined) {
            this._canEdit = (config === null || config === void 0 ? void 0 : config.claimType) ? this.claimsService.hasClaim(config.claimType, [ClaimValues.FullAccess]) : false;
        }
        if (this._canAdd === undefined) {
            this._canAdd = this._canEdit;
        }
        if (this._seeAllUrl === undefined) {
            this._seeAllUrl = this._sharedEntitiesConfig.EntityNamePluralized.toLowerCase().replace(/\s/g, '');
        }
        this.getInitilizationProcesses().subscribe((answer) => {
            this.getEntities();
            this._sharedEntitiesConfig.setMetaItemLists(answer);
        });
    }
    getInitilizationProcesses() {
        let observables = [];
        let metaItemServices = this._sharedEntitiesConfig.MetaItemServices;
        for (let mis of metaItemServices) {
            let metaItemService = this.injector.get(mis);
            observables.push(metaItemService.MetaItemListServiceInitilizer.getItems());
        }
        if (observables.length === 0) {
            return of([]);
        }
        return forkJoin(observables);
    }
    getEntities() {
        if (!this.entitysPassedIn && this.hasService()) {
            const searchEntity = {
                order: this.order,
                orderDirection: this.orderDirection,
                query: '',
                skip: 0,
                take: this._max,
            };
            const searchparams = new SearchParams(searchEntity);
            this.service.getEntities(this.parentId, searchparams).subscribe((response) => {
                this._entities = response.body;
                this._total = +response.headers.get('X-List-Count');
            });
        }
    }
    entitySelected(entity) {
        switch (+this._sharedEntitiesConfig.SharedEntitiesEditOption) {
            case +SharedEntitiesEditOptions.InSeparatePage:
                this.router.navigate([`${this._seeAllUrl}/${entity.Id}`], {
                    relativeTo: this.route,
                });
                break;
            default:
                this.selectedEntity = entity;
                break;
        }
    }
    hasService() {
        return this.service && this.parentId && this.parentId > 0;
    }
    seeAll() {
        this.router.navigate([`${this._seeAllUrl}`], {
            relativeTo: this.route,
        });
    }
    additionalInfo() {
        this.router.navigate([`${this._seeAllUrl}/${this.selectedEntity.Id}`], {
            relativeTo: this.route,
        });
    }
    addEntity() {
        switch (+this._sharedEntitiesConfig.SharedEntitiesEditOption) {
            case +SharedEntitiesEditOptions.InSeparatePage:
                this.router.navigate([`${this._seeAllUrl}/0`], {
                    relativeTo: this.route,
                });
                break;
            default:
                this.selectedEntity = Object.assign({}, this._sharedEntitiesConfig.EmptyEntity);
                break;
        }
    }
    save(entityForm) {
        if (entityForm.valid) {
            // TODO: FIX THIS
            //   entityForm.value.Address = {Address1: entityForm.value.Address1,
            //     Address2: entityForm.value.Addresse2, City: entityForm.value.City, StateCode: entityForm.value.StateCode, Zip: entityForm.value.Zip};
            let entity = this._sharedEntitiesConfig.getFormValues(this.selectedEntity, entityForm.value);
            if (this.entitysPassedIn) {
                this.onSave.emit(entity);
                this.selectedEntity = null;
            }
            else {
                this.saveEntity(entity);
            }
        }
        else {
            this.notificationsService.error('Save Failed');
            markAllFormFieldsAsTouched(entityForm);
        }
    }
    saveEntity(entity) {
        this.service.saveEntity(this.parentId, entity).subscribe((success) => {
            this.notificationsService.success(`${this._sharedEntitiesConfig.EntityName} Saved Successfully`);
            if (this.selectedEntity.Id === 0) {
                // this.selectedEntity.Id = success;
            }
            this.onSave.emit(this.selectedEntity);
            this.selectedEntity = null;
            this.getEntities();
        }, (error) => this.notificationsService.error('Save Failed'));
    }
    cancel() {
        this.selectedEntity = null;
    }
    delete() {
        if (this.entitysPassedIn) {
            this.onDelete.emit(this.selectedEntity);
            this.selectedEntity = null;
        }
        else {
            this.deleteEntity();
        }
    }
    deleteEntity() {
        this.service.deleteEntity(this.parentId, this.selectedEntity.Id).subscribe((success) => {
            this.notificationsService.success(`${this._sharedEntitiesConfig.EntityName} Deleted`);
            this.onDelete.emit(this.selectedEntity);
            this.selectedEntity = null;
            this.getEntities();
        }, (error) => this.notificationsService.error('Delete Failed'));
    }
}
SharedEntitiesComponent.ɵfac = function SharedEntitiesComponent_Factory(t) { return new (t || SharedEntitiesComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NotificationsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ClaimsService)); };
SharedEntitiesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SharedEntitiesComponent, selectors: [["shared-entities"]], inputs: { sharedEntity: ["sharedEntityId", "sharedEntity"], entitiesArray: "entitiesArray", total: "total", canEdit: "canEdit", canAdd: "canAdd", seeAllUrl: "seeAllUrl", max: "max", additionalInfoButtonOverride: "additionalInfoButtonOverride" }, outputs: { onSave: "onSave", onDelete: "onDelete" }, decls: 4, vars: 2, consts: [["class", "miles-card padded", 4, "ngIf"], ["class", "miles-form padded", 4, "ngIf"], [1, "miles-card", "padded"], [1, "list-group"], ["class", "list-group-item", 3, "click", 4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "fab-wrap", 3, "hidden"], ["type", "button", 1, "btn", "btn-primary", "btn-fab-md", "btn-fab-center", 3, "click"], [1, "fa", "fa-plus"], [1, "pull-right", "max-of-total"], [1, "show-on-hover"], [1, "btn", "btn-primary", "btn-flat", "see-all", 3, "click"], [1, "list-group-item", 3, "click"], [3, "innerHTML"], [1, "miles-form", "padded"], [3, "config", "submitted"], ["type", "submit", "Class", "btn btn-flat btn-success"], ["type", "button", "Class", "btn btn-flat btn-default", 3, "click"], ["type", "button", "Class", "pull-right btn btn-flat btn-default", 3, "click", 4, "ngIf"], ["type", "button", "Class", "pull-right btn btn-flat btn-default", 3, "click"]], template: function SharedEntitiesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SharedEntitiesComponent_div_0_Template, 32, 6, "div", 0);
        ɵngcc0.ɵɵtext(1, "\n");
        ɵngcc0.ɵɵtemplate(2, SharedEntitiesComponent_div_2_Template, 16, 3, "div", 1);
        ɵngcc0.ɵɵtext(3, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isEditing);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isEditing);
    } }, directives: [ɵngcc4.NgIf, ɵngcc4.NgForOf, ɵngcc5.DynamicFormComponent], encapsulation: 2 });
SharedEntitiesComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: Router },
    { type: Injector },
    { type: NotificationsService },
    { type: ClaimsService }
];
SharedEntitiesComponent.propDecorators = {
    sharedEntity: [{ type: Input, args: ['sharedEntityId',] }],
    entitiesArray: [{ type: Input, args: ['entitiesArray',] }],
    total: [{ type: Input, args: ['total',] }],
    canEdit: [{ type: Input, args: ['canEdit',] }],
    canAdd: [{ type: Input, args: ['canAdd',] }],
    seeAllUrl: [{ type: Input, args: ['seeAllUrl',] }],
    max: [{ type: Input, args: ['max',] }],
    additionalInfoButtonOverride: [{ type: Input, args: ['additionalInfoButtonOverride',] }],
    onSave: [{ type: Output, args: ['onSave',] }],
    onDelete: [{ type: Output, args: ['onDelete',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SharedEntitiesComponent, [{
        type: Component,
        args: [{
                selector: 'shared-entities',
                template: "<div class=\"miles-card padded\" *ngIf=\"!isEditing\">\n    <h4>{{ _sharedEntitiesConfig.EntityNamePluralized }}</h4>\n    <ul class=\"list-group\">\n        <li *ngFor=\"let entity of entitiesArray\" (click)=\"entitySelected(entity)\" class=\"list-group-item\">\n            <div [innerHTML]=\"_sharedEntitiesConfig.getRow(entity)\"></div>\n        </li>\n    </ul>\n    <i *ngIf=\"!entitiesArray.length\">No {{ _sharedEntitiesConfig.EntityNamePluralized }}</i>\n    <div [hidden]=\"!_canAdd\" class=\"fab-wrap\">\n        <button type=\"button\" class=\"btn btn-primary btn-fab-md btn-fab-center\" (click)=\"addEntity()\">\n            <span class=\"fa fa-plus\"></span>\n        </button>\n    </div>\n    <div class=\"pull-right max-of-total\">\n        <span>{{ _max > _total ? _total : _max }} of {{ _total }}</span>\n    </div>\n    <div class=\"show-on-hover\">\n        <a (click)=\"seeAll()\" class=\"btn btn-primary btn-flat see-all\">Open Search</a>\n    </div>\n</div>\n<div class=\"miles-form padded\" *ngIf=\"isEditing\">\n    <h4>\n        {{ (selectedEntity.Id > 0 ? 'Edit ' : 'Add ') + _sharedEntitiesConfig.EntityName }}\n    </h4>\n    <app-dynamic-form [config]=\"formObject\" (submitted)=\"save($event)\">\n        <button type=\"submit\" Class=\"btn btn-flat btn-success\">\n            Save\n        </button>\n        <button type=\"button\" Class=\"btn btn-flat btn-default\" (click)=\"selectedEntity = null\">\n            Cancel\n        </button>\n        <button *ngIf=\"showAdditionalInfoButton\" type=\"button\" Class=\"pull-right btn btn-flat btn-default\" (click)=\"additionalInfo()\">\n            {{ additionalInfoButtonOverride ? additionalInfoButtonOverride : 'Additional Info' }}\n        </button>\n    </app-dynamic-form>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc1.ActivatedRoute }, { type: ɵngcc1.Router }, { type: ɵngcc0.Injector }, { type: ɵngcc3.NotificationsService }, { type: ɵngcc2.ClaimsService }]; }, { onSave: [{
            type: Output,
            args: ['onSave']
        }], onDelete: [{
            type: Output,
            args: ['onDelete']
        }], sharedEntity: [{
            type: Input,
            args: ['sharedEntityId']
        }], entitiesArray: [{
            type: Input,
            args: ['entitiesArray']
        }], total: [{
            type: Input,
            args: ['total']
        }], canEdit: [{
            type: Input,
            args: ['canEdit']
        }], canAdd: [{
            type: Input,
            args: ['canAdd']
        }], seeAllUrl: [{
            type: Input,
            args: ['seeAllUrl']
        }], max: [{
            type: Input,
            args: ['max']
        }], additionalInfoButtonOverride: [{
            type: Input,
            args: ['additionalInfoButtonOverride']
        }] }); })();

class SharedEntitiesModule {
}
SharedEntitiesModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SharedEntitiesModule });
SharedEntitiesModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SharedEntitiesModule_Factory(t) { return new (t || SharedEntitiesModule)(); }, imports: [[
            CommonModule,
            NgbModule,
            RouterModule,
            DynamicFormModule,
            MtAlertsModule,
            MtSearchFilterSelectModule,
            EntityListModule,
            MtSearchBarControlModule,
            EntityComponentsPhonesModule,
            EntityComponentsAddressesModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SharedEntitiesModule, { declarations: function () { return [SharedEntitiesComponent, SharedEntitiesListComponent, SharedEntitiesInfoComponent, SharedEntityComponent]; }, imports: function () { return [CommonModule,
        NgbModule,
        RouterModule,
        DynamicFormModule,
        MtAlertsModule,
        MtSearchFilterSelectModule,
        EntityListModule,
        MtSearchBarControlModule,
        EntityComponentsPhonesModule,
        EntityComponentsAddressesModule]; }, exports: function () { return [SharedEntitiesComponent, SharedEntitiesListComponent, SharedEntitiesInfoComponent, SharedEntityComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SharedEntitiesModule, [{
        type: NgModule,
        args: [{
                declarations: [SharedEntitiesComponent, SharedEntitiesListComponent, SharedEntitiesInfoComponent, SharedEntityComponent],
                exports: [SharedEntitiesComponent, SharedEntitiesListComponent, SharedEntitiesInfoComponent, SharedEntityComponent],
                imports: [
                    CommonModule,
                    NgbModule,
                    RouterModule,
                    DynamicFormModule,
                    MtAlertsModule,
                    MtSearchFilterSelectModule,
                    EntityListModule,
                    MtSearchBarControlModule,
                    EntityComponentsPhonesModule,
                    EntityComponentsAddressesModule,
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AdditionalSharedEntityConfig, AdditionalSharedEntityTypes, BlankSharedEntitiesConfig, BlankSharedEntityConfig, SharedEntitiesComponent, SharedEntitiesComponentConfig, SharedEntitiesEditOptions, SharedEntitiesInfoComponent, SharedEntitiesListComponent, SharedEntitiesModule, SharedEntitiesService, SharedEntityComponent, SharedEntityComponentConfig, SharedEntityService };

//# sourceMappingURL=mt-ng2-shared-entities-module.js.map